import React from "react";

const Social = ()=> {
    return(
        <div className="home__social">
            <a href="https://x.com/swayamkhatter" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-twitter"></i>
            </a>
            <a href="https://www.linkedin.com/in/swayam-khatter-525353219/" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-linkedin"></i>
            </a>
            <a href="https://github.com/SwayamKhatter" className="home__social-icon" target="_blank" rel="noreferrer">
                <i className="uil uil-github-alt"></i>
            </a>
        </div>
    )
}

export default Social